import type { AccessTag, Fest, FestKind, OvernightKind } from "../types";

export const KIND_LABELS: Record<FestKind, string> = {
  extreme: "Death / black / grind",
  metal: "Metal / hard rock",
  pagan: "Pagan / heathen",
  goth: "Goth / wave",
  folk: "Folk / ritual",
};

export const KIND_COLORS: Record<FestKind, { color: string; fill: string }> = {
  extreme: { color: "#FA5468", fill: "#D32A46" },
  metal: { color: "#E2991A", fill: "#E2991A" },
  pagan: { color: "#68AAA0", fill: "#2D92A4" },
  goth: { color: "#FA5468", fill: "#172B2D" },
  folk: { color: "#F6BB51", fill: "#68AAA0" },
};

export const TAG_LABELS: Record<AccessTag, string> = {
  "on-site-camp": "On the lot",
  "nearby-camp": "Camp nearby",
  "rv-friendly": "RV-friendly",
  "tent-lot": "Tent camping",
  hookups: "Hookups",
  "dry-lot": "Dry / no hookup",
  "day-trip": "Day trip",
  shuttle: "Shuttle",
};

export function primaryKind(fest: Fest): FestKind {
  return fest.kinds[0] ?? "metal";
}

export function kindLabel(fest: Fest): string {
  return fest.kinds.map((k) => KIND_LABELS[k]).join(" · ");
}

export function overnightLabel(kind: OvernightKind): string {
  if (kind === "on-site") return "On the lot";
  if (kind === "nearby") return "Camp nearby";
  return "Hotels / day trip";
}

export function matchesFilters(
  fest: Fest,
  filters: {
    region: Fest["region"] | "";
    kind: FestKind | "";
    camp: boolean;
    rvFriendly: boolean;
  },
): boolean {
  if (filters.region && fest.region !== filters.region) return false;
  if (filters.kind && !fest.kinds.includes(filters.kind)) return false;
  if (filters.camp && fest.overnight === "day-trip") return false;
  if (filters.rvFriendly && !fest.rvFriendly) return false;
  return true;
}
